<template>
  <div id="agree-wrap" v-if="!isAgreeObituary">
    <div class="button_wrap">
      <p>
        '개인정보 동의 후 부고 확인' 을 눌러 <br />
        <b @click="popup('/secure')">개인정보 수집 및 이용</b>에 동의합니다.
      </p>
      <button @click="handleAgreeObituary">개인정보 수집 및 이용 동의</button>
    </div>
  </div>
  <main v-else>
    <obituary-audio-button
      :obituaryDetail="obituaryDetail"
      :volumeMute="volumeMute"
      @mute="$emit('mute')"
    />
    <section>
      <obituary-member-info :obituaryMembers="obituaryMembers" />
      <obituary-map-info :obituaryDetail="obituaryDetail" />
    </section>
    <div class="divider__2"></div>
    <section>
      <obituary-navi-info :obituaryDetail="obituaryDetail" />

      <obituary-banner-list v-if="isExBannerList" :skinBanner="skinBanner" />

      <obituary-bottom-buttons
        @requestShareBugo="requestShareBugo"
        @requestAccountList="requestAccountList"
        @goShop="$emit('goShop')"
        :accountYn="accountYn"
        :obituaryDetail="obituaryDetail"
      />
    </section>

    <obituary-send-modal
      v-if="obituarySendFlag"
      :sendObituary="obituaryDetail"
      @close="obituarySendFlag = false"
    />

    <v-bottom-sheet v-model="accountViewFlag" inset>
      <v-sheet height="auto">
        <account-list
          :accountViewFlag="accountViewFlag"
          @close="accountViewFlag = !accountViewFlag"
        />
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="showSnsList" inset>
      <v-sheet class="text-center" height="auto">
        <sns-list @close="showSnsList = !showSnsList" />
      </v-sheet>
    </v-bottom-sheet>
  </main>
</template>

<script>
import ObituaryAudioButton from "./ObituaryAudioButton.vue";
import ObituaryBottomButtons from "./ObituaryBottomButtons.vue";
import ObituaryMapInfo from "./ObituaryMapInfo.vue";
import ObituaryMemberInfo from "./ObituaryMemberInfo.vue";
import SnsList from "../SnsList.vue";
import AccountList from "../AccountList.vue";
import ObituarySendModal from "../../common/ObituarySendModal.vue";
import ObituaryNaviInfo from "./ObituaryNaviInfo.vue";
import ObituaryBannerList from "./ObituaryBannerList.vue";

export default {
  components: {
    ObituaryAudioButton,
    ObituaryMemberInfo,
    ObituaryMapInfo,
    ObituaryBottomButtons,
    SnsList,
    AccountList,
    ObituarySendModal,
    ObituaryNaviInfo,
    ObituaryBannerList
  },
  name: "ObituaryMain",

  props: ["obituaryDetail", "obituaryMembers", "volumeMute", "skinBanner"],
  data() {
    return {
      agreeFlag: false,
      host: this.$route.query.host ? this.$route.query.host : null,
      memberId: this.$route.query.memberId ? this.$route.query.memberId : null,
      bankOnly: this.$route.query.bankOnly ? this.$route.query.bankOnly : null,

      obituarySendFlag: false,
      showSnsList: false,
      accountViewFlag: false
    };
  },

  computed: {
    isAgreeObituary() {
      if (!this.memberId) return true;

      if (this.agreeFlag) return true;

      // 모바일 버전일때만 동의 검증
      const userAgent = window.navigator.userAgent;
      if (
        userAgent.indexOf("iPhone") > -1 ||
        userAgent.indexOf("Android") > -1
      ) {
        return this.getCurrentObituaryMembers[0]?.agree_dt;
      } else {
        return true;
      }
    },

    realObituaryMembersInfo() {
      return this.obituaryDetail?.ObituaryMembers;
    },
    getCurrentObituaryMembers() {
      return (
        this.realObituaryMembersInfo?.filter(v => v.id === +this.memberId) || []
      );
    },
    getSyncObituaryMembers() {
      return (
        this.realObituaryMembersInfo?.filter(
          v => v.memberBankNumber && v.syncFlag
        ) || []
      );
    },

    accountYn() {
      const currentObituaryMembers = this.getCurrentObituaryMembers;
      const syncObituaryMembers = this.getSyncObituaryMembers;

      let obituaryMembersAccount = this.decideObituaryMembersAccount(
        currentObituaryMembers,
        syncObituaryMembers
      );

      return obituaryMembersAccount.some(
        v => v.memberBankNumber && v.memberBankNumber.trim() !== ""
      );
    },

    isExBannerList() {
      return this.skinBanner?.bannerList?.length > 0;
    }
  },

  methods: {
    popup(path) {
      window.open(`${process.env.VUE_APP_BASEURL}${path}`);
    },
    async handleAgreeObituary() {
      await this.$store
        .dispatch(`REQUEST_OBITUARY_AGREE`, {
          memberId: this.memberId
        })
        .then(data => {
          if (!data) return;
          console.log(data);
          alert(
            `개인정보 동의가 완료되었습니다. (동의일시 :${this.KOREAYYYYMMDDEEHHMMDate(
              data.obituaryMember.agree_dt
            )})`
          );

          this.agreeFlag = true;
        });
    },
    requestShareBugo() {
      if (this.host && this.host === "admin") {
        this.obituarySendFlag = true;
        return;
      }

      this.showSnsList = !this.showSnsList;
    },

    requestAccountList() {
      if (this.obituaryDetail?.accountYn) {
        this.accountViewFlag = !this.accountViewFlag;
        console.log(this.obituaryDetail)
      } else {
        alert("조의금 계좌 서비스를 신청하지 않았습니다");
      }
    },

    decideObituaryMembersAccount(current, sync) {
      if (current[0]?.accountViewType === "1") {
        return sync;
      }
      if (
        this.bankOnly === "Y" ||
        current[0]?.accountViewType === "0" ||
        this.memberId
      ) {
        return current;
      } else {
        return sync;
      }
    }
  }
};
</script>

<style></style>
